function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 27.2792C0 25.3725 1.34584 23.7308 3.21554 23.3569L35 17V94L4.78447 100.043C2.3093 100.538 0 98.645 0 96.1208V27.2792Z",
  fill: "#EAEEF4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M70 24L100.216 17.9569C102.691 17.4619 105 19.355 105 21.8792V90.7208C105 92.6275 103.654 94.2692 101.784 94.6431L70 101V24Z",
  fill: "#EAEEF4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M35 17L70 24V101L35 94V17Z",
  fill: "#D8DDEB"
});

var _ref5 = /*#__PURE__*/React.createElement("mask", {
  id: "path-4-inside-1",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M70 24L35 17V17.0004L3.21554 23.3573C1.34584 23.7312 0 25.3729 0 27.2796V96.1212C0 98.6454 2.3093 100.539 4.78447 100.043L35 94.0004V94L70 101L101.784 94.6431C103.654 94.2692 105 92.6275 105 90.7208V21.8792C105 19.355 102.691 17.4619 100.216 17.9569L70 24Z"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M35 17L35.3922 15.0388L33 17H35ZM70 24L69.6078 25.9612H70.3922L70 24ZM35 17.0004L35.3922 18.9616L37 17.0004H35ZM3.21554 23.3573L2.8233 21.3961H2.8233L3.21554 23.3573ZM4.78447 100.043L5.1767 102.005H5.1767L4.78447 100.043ZM35 94.0004L35.3922 95.9615L37 94.0004H35ZM35 94L35.3922 92.0388L33 94H35ZM70 101L69.6078 102.961H70.3922L70 101ZM101.784 94.6431L101.392 92.6819L101.784 94.6431ZM100.216 17.9569L100.608 19.9181L100.216 17.9569ZM34.6078 18.9612L69.6078 25.9612L70.3922 22.0388L35.3922 15.0388L34.6078 18.9612ZM37 17.0004V17H33V17.0004H37ZM34.6078 15.0392L2.8233 21.3961L3.60777 25.3184L35.3922 18.9616L34.6078 15.0392ZM2.8233 21.3961C0.0187606 21.957 -2 24.4195 -2 27.2796H2C2 26.3262 2.67292 25.5054 3.60777 25.3184L2.8233 21.3961ZM-2 27.2796V96.1212H2V27.2796H-2ZM-2 96.1212C-2 99.9075 1.46395 102.747 5.1767 102.005L4.39224 98.0823C3.15465 98.3298 2 97.3833 2 96.1212H-2ZM5.1767 102.005L35.3922 95.9615L34.6078 92.0392L4.39224 98.0823L5.1767 102.005ZM37 94.0004V94H33V94.0004H37ZM70.3922 99.0388L35.3922 92.0388L34.6078 95.9612L69.6078 102.961L70.3922 99.0388ZM70.3922 102.961L102.177 96.6043L101.392 92.6819L69.6078 99.0388L70.3922 102.961ZM102.177 96.6043C104.981 96.0434 107 93.5809 107 90.7208H103C103 91.6741 102.327 92.495 101.392 92.6819L102.177 96.6043ZM107 90.7208V21.8792H103V90.7208H107ZM107 21.8792C107 18.0929 103.536 15.2532 99.8233 15.9957L100.608 19.9181C101.845 19.6705 103 20.6171 103 21.8792H107ZM99.8233 15.9957L69.6078 22.0388L70.3922 25.9612L100.608 19.9181L99.8233 15.9957Z",
  fill: "#D8DDEB",
  mask: "url(#path-4-inside-1)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M27 67L34.6501 59.7H64.75L79 45",
  stroke: "url(#paint0_linear)",
  strokeWidth: 2,
  strokeDasharray: "3 3"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.5049 67.3992C14.3862 67.4237 11.8771 70.0299 11.9002 73.221C11.9002 73.3385 11.9002 73.454 11.9101 73.5675L11.9219 73.7417L11.9338 73.8593C12.3299 77.8735 16.2236 81.7418 17.2554 82.7003C17.3968 82.8322 17.6131 82.8322 17.7545 82.7003C18.7863 81.7418 22.6879 77.8735 23.0761 73.8593L23.088 73.7417L23.0998 73.5675V73.221C23.1229 70.0339 20.6198 67.4293 17.5049 67.3992ZM19.8815 73.1338C19.8815 74.4768 18.8175 75.5655 17.5049 75.5655C16.1924 75.5655 15.1284 74.4768 15.1284 73.1338C15.1284 71.7909 16.1924 70.7022 17.5049 70.7022C18.8175 70.7022 19.8815 71.7909 19.8815 73.1338ZM13.9401 73.1338C13.9401 75.1483 15.5361 76.7813 17.5049 76.7813C19.4738 76.7813 21.0698 75.1483 21.0698 73.1338C21.0698 71.1194 19.4738 69.4864 17.5049 69.4864C15.5361 69.4864 13.9401 71.1194 13.9401 73.1338Z",
  fill: "url(#paint1_linear)"
});

var _ref9 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 11,
  y: 67,
  width: 13,
  height: 16
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.5049 67.3992C14.3862 67.4237 11.8771 70.0299 11.9002 73.221C11.9002 73.3385 11.9002 73.454 11.9101 73.5675L11.9219 73.7417L11.9338 73.8593C12.3299 77.8735 16.2236 81.7418 17.2554 82.7003C17.3968 82.8322 17.6131 82.8322 17.7545 82.7003C18.7863 81.7418 22.6879 77.8735 23.0761 73.8593L23.088 73.7417L23.0998 73.5675V73.221C23.1229 70.0339 20.6198 67.4293 17.5049 67.3992ZM19.8815 73.1338C19.8815 74.4768 18.8175 75.5655 17.5049 75.5655C16.1924 75.5655 15.1284 74.4768 15.1284 73.1338C15.1284 71.7909 16.1924 70.7022 17.5049 70.7022C18.8175 70.7022 19.8815 71.7909 19.8815 73.1338ZM13.9401 73.1338C13.9401 75.1483 15.5361 76.7813 17.5049 76.7813C19.4738 76.7813 21.0698 75.1483 21.0698 73.1338C21.0698 71.1194 19.4738 69.4864 17.5049 69.4864C15.5361 69.4864 13.9401 71.1194 13.9401 73.1338Z",
  fill: "white"
}));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M87.5049 33.1004C84.3861 33.1249 81.8771 35.7311 81.9001 38.9221C81.9001 39.0397 81.9001 39.1552 81.91 39.2686L81.9219 39.4429L81.9338 39.5604C82.3299 43.5747 86.2235 47.443 87.2554 48.4015C87.3968 48.5334 87.6131 48.5334 87.7545 48.4015C88.7863 47.443 92.6879 43.5747 93.076 39.5604L93.0879 39.4429L93.0998 39.2686V38.9221C93.1229 35.735 90.6198 33.1305 87.5049 33.1004ZM89.8815 38.835C89.8815 40.178 88.8175 41.2666 87.5049 41.2666C86.1924 41.2666 85.1283 40.178 85.1283 38.835C85.1283 37.492 86.1924 36.4034 87.5049 36.4034C88.8175 36.4034 89.8815 37.492 89.8815 38.835ZM83.94 38.835C83.94 40.8494 85.5361 42.4824 87.5049 42.4824C89.4737 42.4824 91.0698 40.8494 91.0698 38.835C91.0698 36.8206 89.4737 35.1875 87.5049 35.1875C85.5361 35.1875 83.94 36.8206 83.94 38.835Z",
  fill: "url(#paint2_linear)"
});

var _ref12 = /*#__PURE__*/React.createElement("mask", {
  id: "mask1",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 81,
  y: 33,
  width: 13,
  height: 16
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M87.5049 33.1004C84.3861 33.1249 81.8771 35.7311 81.9001 38.9221C81.9001 39.0397 81.9001 39.1552 81.91 39.2686L81.9219 39.4429L81.9338 39.5604C82.3299 43.5747 86.2235 47.443 87.2554 48.4015C87.3968 48.5334 87.6131 48.5334 87.7545 48.4015C88.7863 47.443 92.6879 43.5747 93.076 39.5604L93.0879 39.4429L93.0998 39.2686V38.9221C93.1229 35.735 90.6198 33.1305 87.5049 33.1004ZM89.8815 38.835C89.8815 40.178 88.8175 41.2666 87.5049 41.2666C86.1924 41.2666 85.1283 40.178 85.1283 38.835C85.1283 37.492 86.1924 36.4034 87.5049 36.4034C88.8175 36.4034 89.8815 37.492 89.8815 38.835ZM83.94 38.835C83.94 40.8494 85.5361 42.4824 87.5049 42.4824C89.4737 42.4824 91.0698 40.8494 91.0698 38.835C91.0698 36.8206 89.4737 35.1875 87.5049 35.1875C85.5361 35.1875 83.94 36.8206 83.94 38.835Z",
  fill: "white"
}));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1)"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 67,
  r: 2,
  fill: "url(#paint3_linear)"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 45,
  r: 2,
  fill: "url(#paint4_linear)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35 7.33334C26.8893 7.33334 20.3333 13.8893 20.3333 22C20.3333 30.1107 26.8893 36.6667 35 36.6667C43.1107 36.6667 49.6667 30.1107 49.6667 22C49.6667 13.8893 43.1107 7.33334 35 7.33334ZM41.6262 26.5582C42.0168 26.9488 42.0168 27.5819 41.6262 27.9725L40.9725 28.6262C40.5819 29.0168 39.9488 29.0168 39.5582 28.6262L35 24.068L30.4418 28.6262C30.0513 29.0168 29.4181 29.0168 29.0276 28.6262L28.3738 27.9725C27.9833 27.5819 27.9833 26.9488 28.3738 26.5582L32.932 22L28.7007 17.7687C28.1296 17.1976 28.1296 16.2717 28.7007 15.7007V15.7007C29.2717 15.1296 30.1976 15.1296 30.7687 15.7007L35 19.932L39.5582 15.3738C39.9488 14.9833 40.5819 14.9833 40.9725 15.3738L41.6262 16.0276C42.0168 16.4181 42.0168 17.0513 41.6262 17.4418L37.068 22L41.6262 26.5582Z",
  fill: "#2E3545"
});

var _ref17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 78.5761,
  y1: 66.6733,
  x2: 33.9823,
  y2: 35.1291,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007CFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00BAFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 23.0087,
  y1: 82.5705,
  x2: 9.24973,
  y2: 79.5758,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007CFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00BAFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 93.0087,
  y1: 48.2717,
  x2: 79.2497,
  y2: 45.277,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007CFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00BAFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 23,
  y1: 67,
  x2: 27,
  y2: 71,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00BAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007CFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 75,
  y1: 45,
  x2: 79,
  y2: 49,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00BAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007CFF"
})));

function SvgIconMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 101,
    viewBox: "0 0 105 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = React.forwardRef(SvgIconMap);
export default __webpack_public_path__ + "static/media/icon_map.b66a6c6c.svg";
export { ForwardRef as ReactComponent };